<template>
    <v-data-table v-bind="{ items, headers }" dense hide-default-footer disable-sort disable-filtering disable-pagination no-data-text="등록된 내용이 없습니다" mobile-breakpoint="1024">
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/variables";

const headers = initDataTableHeaders(
    [
        { text: "업체명", value: "CUST_NAME", width: 160 },
        { text: "기종명", value: "MODEL_NAME" },
        { text: "이슈사항", value: "ISSUE" },
        { text: "조치사항", value: "RESULT" },
        { text: "시간", value: "EVENT_DATE", width: 160 },
        { text: "비고", value: "EVENT_DESC" },
    ],
    {
        showsDivider: true,
        className: "font-size-14",
        cellClass: "font-size-14",
    }
);

export default {
    props: {
        process: { type: String },
        planDate: { type: String },
    },
    data: () => ({
        body: [],
        limit: 0,
        summary: { totalCount: 0 },

        loading: false,
        headers,
    }),
    computed: {
        items() {
            return this.body.map((item, index) => ({ ...(item || {}), index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            query.process = this.process;
            query.planDate = this.planDate;

            return { ...query };
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async search() {
            if (!this.process || !this.planDate) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, body } = await api.console.mes.reports.body.gets({
                    headers: { skip, limit },
                    ...params,
                });

                this.summary = summary;
                this.body = body;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style></style>
